import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { getUserData } from '../data';
import env from '../env';

const LD_ANONYMOUS = 'anonymous';

/**
 * Bootstraps the LaunchDarkly provider
 * @returns {Promise<{userData: object, LDProvider: import('react').ReactNode}>} - The user data and the LaunchDarkly provider
 */
export async function bootstrapLD() {
  let userData = {};
  let ldConfig;

  try {
    userData = await getUserData();
    ldConfig = {
      clientSideID: env.ldKey,
      context: {
        kind: 'user',
        key: userData?.user?.wooId || LD_ANONYMOUS,
      },
      options: {
        useReport: true,
      },
    };
  } catch (_) {
    ldConfig = {
      clientSideID: env.ldClientId,
      user: {
        key: LD_ANONYMOUS,
      },
    };
  }

  const LDProvider = await asyncWithLDProvider(ldConfig);

  return {
    userData,
    LDProvider,
  };
}
